import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3beb31fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "documents-file-container py-56" }
const _hoisted_2 = { class: "d-flex mb-56 justify-content-between" }
const _hoisted_3 = { class: "h4 text-primary mb-0" }
const _hoisted_4 = { class: "fw-normal" }
const _hoisted_5 = { class: "top-section d-flex align-items-center justify-content-between" }
const _hoisted_6 = { class: "document-type d-flex align-items-center flex-wrap col-8 col-md-6 col-xl-5 col-xxl-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "view-tabs" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    id: "myTab",
    class: "nav nav-tabs border-0",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        id: "grid-tab",
        "aria-controls": "grid",
        "aria-selected": "true",
        class: "btn btn-icon p-8 active",
        "data-bs-target": "#grid",
        "data-bs-toggle": "tab",
        role: "tab",
        type: "button"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "icon icon-grid" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        id: "list-tab",
        "aria-controls": "list",
        "aria-selected": "false",
        class: "btn btn-icon p-8",
        "data-bs-target": "#list",
        "data-bs-toggle": "tab",
        role: "tab",
        type: "button"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "icon icon-table" })
      ])
    ])
  ])
], -1))
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = {
  id: "grid",
  "aria-labelledby": "grid-tab",
  class: "tab-pane active",
  role: "tabpanel"
}
const _hoisted_10 = {
  id: "list",
  "aria-labelledby": "list-tab",
  class: "tab-pane list-component",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_treeselect = _resolveComponent("treeselect")!
  const _component_the_admin_resources_grid = _resolveComponent("the-admin-resources-grid")!
  const _component_the_admin_resources_list = _resolveComponent("the-admin-resources-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Listado de')), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('recursos')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_treeselect, {
          modelValue: _ctx.typeSelected,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.typeSelected) = $event)),
          multiple: false,
          options: _ctx.categories,
          "disable-branch-nodes": true,
          placeholder: _ctx.$t('Selecciona el tipo de documento')
        }, null, 8, ["modelValue", "options", "placeholder"])
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_the_admin_resources_grid, {
          media: _ctx.media,
          status: _ctx.status,
          onRefreshMedia: _ctx.loadExpedientMedia
        }, null, 8, ["media", "status", "onRefreshMedia"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_the_admin_resources_list, {
          media: _ctx.media,
          status: _ctx.status,
          onRefreshMedia: _ctx.loadExpedientMedia
        }, null, 8, ["media", "status", "onRefreshMedia"])
      ])
    ])
  ]))
}